






















import {Component, Prop, Vue} from "vue-property-decorator";
import {v4 as uuidv4} from "uuid"

@Component({
    components: {}
})
export default class CollapsibleBox extends Vue {
    @Prop() id!: string;
    @Prop() disabled!: boolean;
    @Prop() expanded!: boolean;
    @Prop() closed!: boolean;
    @Prop() unstyledContent!: boolean;

    private internalId: string = uuidv4();

    mounted() {
        this.internalId = this.id ? this.id.toString() : uuidv4();
    }

    fixChosen() {
        $('.chosen-full-width').select2({width: '100%'});
    }
}
